// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9a1zb","col":"styles_col__1vogL"};